import React from 'react';
import { IonButton, IonInput, IonItem, IonList } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { uiInputMode } from '../../utils/ui';

type AccountPersonalFormProps = {
  isValid: boolean;
  proceed: () => void;
  email: string;
  setEmail: (s: string) => void;
  firstName: string;
  setFirstName: (s: string) => void;
  lastName: string;
  setLastName: (s: string) => void;
  phone: string;
  setPhone: (s: string) => void;
};

export default function AccountPersonalForm({
  isValid,
  email,
  setEmail,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  phone,
  setPhone,
  proceed,
}: AccountPersonalFormProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <p className="pb-4 instructions ion-text-center">{t('account.info')}</p>
      <IonList inset={false}>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={firstName}
            aria-label={t('register.firstname')!}
            placeholder={t('register.firstname')!}
            onIonInput={(e) => setFirstName(e.detail.value!)}
            mode={uiInputMode()}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={lastName}
            aria-label={t('register.lastname')!}
            mode={uiInputMode()}
            placeholder={t('register.lastname')!}
            onIonInput={(e) => setLastName(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={email}
            mode={uiInputMode()}
            aria-label={t('register.email')!}
            placeholder={t('register.email')!}
            onIonInput={(e) => setEmail(e.detail.value!)}
            type="email"
            fill="outline"
          ></IonInput>
        </IonItem>
        <IonItem lines="none" className="ion-no-padding ion-pt-1">
          <IonInput
            value={phone}
            mode={uiInputMode()}
            aria-label={t('register.phone')!}
            placeholder={t('register.phone')!}
            onIonInput={(e) => setPhone(e.detail.value!)}
            type="text"
            fill="outline"
          ></IonInput>
        </IonItem>
      </IonList>

      <div className="pt-4 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => proceed()}
        >
          {t('account.savechanges')}
        </IonButton>
      </div>
    </>
  );
}
